import Api from './ApiService'

export default {
    get(start, end, keyword, pageNumber, pageSize, order) {
        return Api().get(`event?start=${start}&end=${end}&keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getOne(id) {
        return Api().get(`event/${id}`);
    },
    create(data) {
        return Api().post(`event`, data);
    },
    update(data) {
        return Api().put(`event/${data.id}`, data);
    },
    delete(id) {
        return Api().delete(`event/${id}`);
    }
}